export const MAX_PRICE = 99999.99;
export const MIN_PRICE = 100;
export let SellHeroError;

(function (SellHeroError) {
  SellHeroError[SellHeroError["NO_ERROR"] = 0] = "NO_ERROR";
  SellHeroError[SellHeroError["MAX_AMOUNT_EXCEEDED"] = 1] = "MAX_AMOUNT_EXCEEDED";
  SellHeroError[SellHeroError["MIN_AMOUNT_EXCEEDED"] = 2] = "MIN_AMOUNT_EXCEEDED";
  SellHeroError[SellHeroError["MAX_DECIMAL_EXCEEDED"] = 3] = "MAX_DECIMAL_EXCEEDED";
})(SellHeroError || (SellHeroError = {}));